import { Assignment as ProjekteIcon } from '@mui/icons-material';

import { AppFeature } from '../../components/dcbApp/types';

import { ProjektListScreen } from './list/ProjektListScreen';
import { CreateProjektDialogForm } from './save/CreateProjektDialogForm';
import { UpdateProjektStammDatenDialogForm } from './save/EditProjektStammdatenDialogForm';
import { ProjektViewScreen } from './view/ProjektViewScreen';

export const projektFeature: AppFeature = {
  path: 'projekte',
  label: 'Projekte',
  icon: <ProjekteIcon sx={{ color: 'secondary.main' }} />,
  list: <ProjektListScreen />,
  view: <ProjektViewScreen />,
  dialogs: [<CreateProjektDialogForm />, <UpdateProjektStammDatenDialogForm />],
};
